import { useCallback } from 'react';
import { DeepPartial } from 'react-hook-form';

import { QuoteFormSchema } from 'features/Work/form/quoteForm.schema';
import { getUser } from 'helpers/auth';

import { TTL } from '../constants';

const KEY_PREFIX = '@Quote:';

export const useCachedQuote = () => {
  const user = getUser();

  const cacheKey = `${KEY_PREFIX}${user?.uid}`;
  const cacheItem = localStorage.getItem(cacheKey);

  let cachedQuote =
    cacheItem === null ? null : (JSON.parse(cacheItem) as QuoteFormSchema);

  const clearCachedQuote = useCallback(
    () => localStorage.removeItem(cacheKey),
    [cacheKey],
  );

  const setCachedQuote = useCallback(
    (quote: DeepPartial<QuoteFormSchema>) =>
      localStorage.setItem(
        cacheKey,
        JSON.stringify({ ...quote, lastEditedAt: new Date().valueOf() }),
      ),
    [cacheKey],
  );

  // if the quote in cache is older than the defined TTL, discard it
  if (
    cachedQuote !== null &&
    cachedQuote.lastEditedAt &&
    cachedQuote.lastEditedAt + TTL < new Date().valueOf()
  ) {
    clearCachedQuote();
    cachedQuote = null;
  }

  return {
    cachedQuote,
    clearCachedQuote,
    setCachedQuote,
  };
};
